
import { mapActions, mapState, mapMutations } from "vuex";
import CreateEditAddonDialog from "../dialogs/create-edit-addon-dialog.vue";
import MenuUploadCreateAddonDialog from "../dialogs/menu-upload-create-addon-dialog.vue";
import MenuUploadCreateChoiceDialog from "../dialogs/menu-upload-create-choice-dialog.vue";
import MenuUploadCreateChoiceGroupDialog from "../dialogs/menu-upload-create-choice-group-dialog.vue";
import MenuUploadEmptyAddonDialog from "../dialogs/menu-upload-empty-addon-dialog.vue";
import MenuUploadGridItemAddonGroup from "./menu-upload-grid-item-addon-group.vue";
import menuUploadGridItemAvatarName from "./menu-upload-grid-item-avatar-name.vue";
export default {
  components: {
    menuUploadGridItemAvatarName,
    MenuUploadCreateAddonDialog,
    CreateEditAddonDialog,
    MenuUploadGridItemAddonGroup,
    MenuUploadEmptyAddonDialog,
    MenuUploadCreateChoiceDialog,
    MenuUploadCreateChoiceGroupDialog
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showMenuUploadCreateChoiceGroupDialog: false,
      showAddNewChoiceDialog: false,
      showEmptyAddonDialog: false,
      editingInfo: null,
      selectedChoiceInfo: null,
      selectedIndex: null,
      selectedChoiceIndex: null,
      choices: [],
      newlyAddedChoice: []
    };
  },
  methods: {
    ...mapMutations("menu", [
      "UPDATE_CHOICE_GROUP",
      "MAP_CHOICE_TO_ITEM",
      "DELETE_CHOICE_GROUP"
    ]),
    handleShowCreateChoiceDialog(data) {
      if (data && data.groupInfo) {
        this.editingInfo = data.groupInfo;
        this.selectedIndex = data.index;
        this.showMenuUploadCreateChoiceGroupDialog = true;
      } else {
        this.showAddNewChoiceDialog = true;
      }
    },
    handleCreateChoiceGroupDialogClose() {
      this.showMenuUploadCreateChoiceGroupDialog = false;
      this.selectedIndex = null;
      this.editingInfo = null;
      this.newlyAddedChoice = [];
    },

    handleCreateOrEditChoice(choice) {
      if (this.selectedIndex !== null) {
        // Update existing choice
        const choiceInfos = JSON.parse(
          JSON.stringify(this.item.choices[this.selectedIndex])
        );
        if (this.selectedChoiceIndex !== null) {
          choiceInfos.selectedItems[this.selectedChoiceIndex] = choice;
        } else {
          choiceInfos.selectedItems.push(choice);
        }
        this.UPDATE_CHOICE_GROUP({
          itemId: this.item.id,
          choiceIndex: this.selectedIndex,
          choiceInfos
        });
      } else {
        if (this.selectedChoiceIndex !== null) {
          const newlyAddedChoice = JSON.parse(
            JSON.stringify(this.newlyAddedChoice)
          );
          newlyAddedChoice[this.selectedChoiceIndex] = choice;
          this.newlyAddedChoice = newlyAddedChoice;
        } else {
          this.newlyAddedChoice.push(choice);
        }
        this.showMenuUploadCreateChoiceGroupDialog = true;
      }
      this.selectedChoiceIndex = null;
      this.showAddNewChoiceDialog = false;
    },
    handleShowCreateChoicesDialog() {
      if (this.choices.length) {
        this.showMenuUploadCreateChoiceGroupDialog = true;
      } else {
        this.showAddNewChoiceDialog = true;
      }
    },
    handleDeleteChoiceGroup(itemId, index) {
      this.DELETE_CHOICE_GROUP(itemId, index);
    },
    addNewChoice() {
      this.selectedChoiceIndex = null;
      this.showAddNewChoiceDialog = true;
    },
    handleEditChoice({ choice, index }) {
      this.showAddNewChoiceDialog = true;
      this.selectedChoiceInfo = choice;
      this.selectedChoiceIndex = index;
    },

    handleDeleteChoice(index) {
      if (this.selectedIndex !== null) {
        const choiceInfos = JSON.parse(
          JSON.stringify(this.item.choices[this.selectedIndex])
        );
        choiceInfos.selectedItems.splice(index, 1);

        if (choiceInfos.selectedItems.length <= 0) {
          this.DELETE_CHOICE_GROUP({
            itemId: this.item.id,
            index: this.selectedIndex
          });
          this.selectedIndex = null;
          this.editingInfo = null;
          this.newlyAddedChoice = [];
        } else {
          this.UPDATE_CHOICE_GROUP({
            itemId: this.item.id,
            choiceIndex: this.selectedIndex,
            choiceInfos
          });
        }
      } else {
        this.newlyAddedChoice.splice(index, 1);
      }
    }
  }
};
